import Swiper from "swiper";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

{
    const installationVariationsTopThumbs = new Swiper(".js-installation-variations-top-thumbs", {
        spaceBetween: 24,
        slidesPerView: 4,
        observer: true,
        shortSwipes: false,
        watchOverflow: true,
    });

    new Swiper(".js-installation-variations-thumbs-slider", {
        spaceBetween: 10,

        // navigation: {
        //     nextEl: ".js-benefits-thumbs-controls .swiper-button-next",
        //     prevEl: ".js-benefits-thumbs-controls .swiper-button-prev",
        // },
        // pagination: {
        //     el: ".js-benefits-thumbs-controls .swiper-pagination",
        //     dynamicBullets: true,
        //     dynamicMainBullets: 3,
        //     clickable: true,
        // },
        thumbs: {
            swiper: installationVariationsTopThumbs,
        },
    });
}

const adviceMovers = document.querySelectorAll(".js-move-to-advice");
const adviceAccordions = document.querySelectorAll(".js-accordion");

if (adviceMovers && adviceAccordions) {
    adviceMovers.forEach((item) => {
        item.addEventListener("click", () => {
            const advice = document.getElementById(item.getAttribute("data-id"));

            if (advice) {
                const accordion = advice.closest(".js-accordion");

                if (accordion) {
                    accordion.querySelector(".js-accordion-toggle-btn").click();
                    elementScrollIntoView(accordion, { behavior: "smooth", block: "start" });
                }
            }
        });
    });
}
